import React from "react";
import { AutoComplete } from "antd";
import * as companyService from "services/companyService";
const { Option } = AutoComplete;

export default class InputComplete extends React.PureComponent {
  state = {
    positionName: {}
  };

  /**
   * @description 获取职位名
   * @param {string} value
   */
  positionNameFetch = (value, callback) => {
    const {
      requestFunc,
      setSearchVal = undefined,
      setSearchExpand = {}
    } = this.props;
    if (this.posNameTimeout) {
      clearTimeout(this.posNameTimeout);
      this.posNameTimeout = null;
    }
    this.posNameCurValue = value;

    const fake = () => {
      if (!value) {
        return callback([]);
      }

      this.setState({
        positionName: {
          ...this.state.positionName
        }
      });
      /**
       * @description 请求数据
       */
      requestFunc({
        name: value,
        company_id: setSearchVal,
        ...setSearchExpand
      }).then(res => {
        if (this.posNameCurValue === value && res && res.code === 0) {
          if (JSON.stringify(setSearchExpand) !== "{}") {
            let data = res.data.list || [];
            let result = data.map(res => res.name);
            result = result.filter(text => text.name !== value);
            console.log(result, "rr");
            // result=["科锐200","dsfds"]
            callback(result);
          } else {
            let result = res.data || [];
            result = result.filter(text => text !== value);
            console.log(result, "rr");
            callback(result);
          }
        }
        this.setState({
          positionName: {
            ...this.state.positionName,
            fetching: false
          }
        });
      });
    };

    this.posNameTimeout = setTimeout(fake, 300);
  };
  /**
   * @description 搜索赋值
   */
  handlePosNameSearch = value => {
    this.positionNameFetch(value, data => {
      this.setState({
        positionName: {
          ...this.state.positionName,
          options: data
        }
      });
    });
  };
  render() {
    const { dataSource, onSearch, custom, ...props } = this.props;
    const { positionName } = this.state;
    let children = [];
    if (custom) {
      children = positionName.options ? positionName.options.map(item => {
        return <Option key={item} title={item}>{item}</Option>
      }) : [];
    };
    return (
      <React.Fragment>
      {
        custom ?
        <AutoComplete
          {...props}
          onSearch={this.handlePosNameSearch}
        >
          {children}
        </AutoComplete>
        :
        <AutoComplete
          {...props}
          dataSource={positionName.options}
          onSearch={this.handlePosNameSearch}
        />
      }
      </React.Fragment>
    );
  }
}
